/* eslint-disable arrow-parens */
import { useState, useEffect, useCallback, Suspense, useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import { AuthContext, DependentContext } from "../../../../../../contexts";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { EnrollmentSchema, VEBEnrollmentSchema } from "../../../../../../types/enrollment.types";
import { api } from "../../../../../../utils/api";
import { GetDependentBenefitsQuery } from "../../../../../../utils/api/enrollment/enrollment";
import { ThemeFormSubHeader } from "../../../../../shared/themeFormSubHeader";
import DependentBenefitsGrid from "./dependentBenefitsGrid/DependentBenefitsGrid";

const GroupBenefits = () => {
	const [dependentGroupBenefits, setDependentGroupBenefits] = useState([]);
	const [dependentCurrentGroupBenefits, setDependentCurrentGroupBenefits] = useState([]);
	const [dependentFutureGroupBenefits, setDependentFutureGroupBenefits] = useState([]);
	const [dependentBenefits, setDependentBenefits] = useState<EnrollmentSchema[]>([]);
	const { member } = useContext(AuthContext);
	const { dependent } = useContext(DependentContext);

	// const dependentAssignBenefits = useCallback((dependentBenefits) => {
	// 	const _dependentCurrentGroupBenefits = [];
	// 	dependentBenefits.forEach((eachDependentBenefit) => {

	// 	})

	// }, []);

	const getDependentBenefits = useCallback(async () => {
		if (member === null || (member?.role === "EMPLOYEE" && dependent === null) || !dependent) {
			return;
		}
		const getDependentBenefitsQuery: GetDependentBenefitsQuery = {
			insured_SSN: member.role === "EMPLOYEE" ? member.SSN : member.employee_SSN,
			member_SSN: member.role === "EMPLOYEE" ? dependent.SSN : member.SSN,
			group_number: member.group_number
		};
		const _dependentBenefits: EnrollmentSchema[] = await trackPromise(
			api.enrollment.getDependentBenefits(getDependentBenefitsQuery)
		);
		const _dependentCurrentGroupBenefits: any = [];
		const _dependentFutureGroupBenefits: any = [];
		_dependentBenefits.forEach((dependentBenefit) => {
			if (new Date(dependentBenefit.effective_date as any) <= new Date()) {
				_dependentCurrentGroupBenefits.push(dependentBenefit);
			} else {
				_dependentFutureGroupBenefits.push(dependentBenefit);
			}
		});
		setDependentCurrentGroupBenefits(Object.assign([], _dependentCurrentGroupBenefits));
		setDependentFutureGroupBenefits(Object.assign([], _dependentFutureGroupBenefits));
		// console.log("DependentBenefits", _dependentBenefits);
		// setDependentBenefits(Object.assign([], _dependentBenefits));
		// dependentAssignBenefits(dependentBenefits);
	}, [dependent, member]);

	// const getGroupBenefits = useCallback(() => {
	// 	setDependentGroupBenefits(
	// 		Object.assign(
	// 			[],
	// 			[
	// 				{
	// 					plan_name: "Christmas Club Election Form",
	// 					plan_code: "CCEF-ALL",
	// 					relationship: "Spouse",
	// 					submit_date: "12/10/2021",
	// 					start_date: "05/01/2022",
	// 					end_date: "Current",
	// 					status: "Active",
	// 					plan_approved_by: "Anupam Biswas",
	// 					update_on: "11/10/2022"
	// 				},
	// 				{
	// 					plan_name: "Christmas Club Election Form",
	// 					plan_code: "CCEF-ALL",
	// 					relationship: "Daughter",
	// 					submit_date: "12/10/2021",
	// 					start_date: "05/01/2022",
	// 					end_date: "Current",
	// 					status: "Active",
	// 					plan_approved_by: "Anupam Biswas",
	// 					update_on: "11/10/2022"
	// 				}
	// 			]
	// 		)
	// 	);
	// }, []);

	useEffect(() => {
		getDependentBenefits();
		// getGroupBenefits();
	}, [getDependentBenefits]);

	return (
		<>
			{/* <DependentBenefitsGrid benefits={dependentBenefits} /> */}
			<div className="benefits-container">
				<div className="pf-container-title">Current Benefits</div>
				<DependentBenefitsGrid benefits={dependentCurrentGroupBenefits} />
				<div className="pf-title">Future Benefits</div>
				<DependentBenefitsGrid benefits={dependentFutureGroupBenefits} />
			</div>
		</>
	);
};

export default GroupBenefits;
